import { render, staticRenderFns } from "./CompanyContract.vue?vue&type=template&id=18a05427&"
import script from "./CompanyContract.vue?vue&type=script&lang=js&"
export * from "./CompanyContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports